import { render, staticRenderFns } from "./SeatChart.vue?vue&type=template&id=267e4fe8&scoped=true&"
import script from "./SeatChart.vue?vue&type=script&lang=js&"
export * from "./SeatChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267e4fe8",
  null
  
)

export default component.exports